import React, { useEffect, useState } from 'react'

import styles from './styles.module.css'
import { ApiCore, useLogin } from '@monorepo/api'

interface Props {
  errorMessage: string
  loginType: 'phone' | 'email'
  langKey?: string
  isBalancerInfoLoading?: boolean
  balancerInfo?: ApiCore.CDALandingsResponse | null
}

const dictionary = {
  errors: [
    'already exists', // en
    'бұрыннан бар', // kz
    'уже существует', // ru
    'буга чейин бар', // kg
    'zaten mevcut', // tr
    'allaqachon mavjud', // uz
    'artıq mövcuddur', // az
  ],

  email: {
    en: 'This address is already linked to an existing account. To continue',
    kz: 'Бұл мекенжай бұрыннан бар тіркелгімен байланыстырылған. Жалғастыру үшін',
    ru: 'Этот адрес уже привязан к существующему аккаунту. Чтобы продолжить, выполните',
    kg: 'Бул дарек мурдатан бар болгон аккаунтка байланган. Улантуу үчүн, каттоо эсебине кириңиз',
    tr: 'Bu adres mevcut bir hesaba zaten bağlı. Devam etmek için hesabınıza giriş yapın',
    uz: "Ushbu elektron pochta manzili allaqachon mavjud hisob bilan bog'langan. Davom etish uchun hisobingizga kiring.",
    az: 'Bu ünvan artıq mövcud hesabla əlaqələndirilib. Davam etmək üçün hesabınıza daxil olun.',
  },

  number: {
    en: 'This phone number is already linked to an existing account. To continue',
    ru: 'Этот номер телефона уже привязан к существующему аккаунту. Чтобы продолжить, выполните',
    kz: 'Бұл телефон нөмірі бұрыннан бар тіркелгімен байланыстырылған. Жалғастыру үшін',
    kg: 'Бул телефон номери мурдатан бар болгон аккаунтка байланган. Улантуу үчүн, каттоо эсебине кириңиз.',
    tr: 'Bu telefon numarası zaten mevcut bir hesaba bağlı. Devam etmek için hesabınıza giriş yapın.',
    uz: "Bu telefon raqami allaqachon mavjud hisob bilan bog'langan. Davom etish uchun hisobingizga kiring.",
    az: 'Bu telefon nömrəsi artıq mövcud hesabla əlaqələndirilib. Davam etmək üçün hesabınıza daxil olun.',
  },

  login: {
    en: 'login',
    kz: 'Кіру',
    ru: 'вход',
    kg: 'Киришиңиз',
    tr: 'Giriş',
    uz: 'Kirish',
    az: 'Giriş',
  },
}
type SupportedLang = keyof typeof dictionary.login
const languageAliases: Record<string, SupportedLang> = {
  ky: 'kg',
}

const UserAlreadyExists: React.FC<Props> = ({
  errorMessage,
  loginType,
  langKey,
  isBalancerInfoLoading,
  balancerInfo,
}) => {
  const { redirectToLoginPage } = useLogin({ isBalancerInfoLoading, balancerInfo })
  const [description, setDescription] = useState<string | null>(null)
  const [login, setLogin] = useState<string | null>(null)

  useEffect(() => {
    const raw = (
      langKey ??
      localStorage.getItem('i18nextLng') ??
      localStorage.getItem('preferredLanguage') ??
      'ru'
    )
      .slice(0, 2)
      .toLowerCase() // 'ru-RU' → 'ru'

    // Если язык не поддерживается — fallback на ru
    const preferred: SupportedLang =
      languageAliases[raw] ?? (raw in dictionary.login ? (raw as SupportedLang) : 'ru')
    setDescription(
      loginType === 'email' ? dictionary.email[preferred] : dictionary.number[preferred],
    )
    setLogin(dictionary.login[preferred])
  }, [langKey, loginType])
  const showError = dictionary.errors.some((err) => errorMessage.includes(err))

  return (
    showError && (
      <div className={styles.userExistsErrorContainer}>
        <span className={styles.errorChar}>&#9888;</span>
        <span>
          {description}
          <a className={styles.loginText} onClick={redirectToLoginPage}>
            {login}
          </a>
          .
        </span>
      </div>
    )
  )
}

export default UserAlreadyExists
